import * as React from "react"

function ItemSearchScorecard(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 350" {...props}>
      <style>
        {
          ".item-search-scorecard_st2{fill:#00aeef}.item-search-scorecard_st3{fill:#fff}.item-search-scorecard_st5{fill:#1eca8a}.item-search-scorecard_st7{fill:#c1c6cb}.item-search-scorecard_st8{fill:#a7d134}.item-search-scorecard_st9{fill:#f0c622}.item-search-scorecard_st11{fill:#f0b922}.item-search-scorecard_st12{fill:#ed5407}.item-search-scorecard_st13{fill:#f93b3b}"
        }
      </style>
      <g id="item-search-scorecard_Guides_and_Back_00000084529498973680906690000002728537902753595822_">
        <path
          className="item-search-scorecard_st2"
          d="M30.5 31.1C62 5.9 105.4 54.9 199.3 66.9 333.9 84.2 378.5.6 466.4 32.4 547.6 61.7 609 168.9 582.6 231.1c-16.3 38.6-75.7 51.4-193.8 75.6-145.4 29.8-219.3 43.8-276.9 3.9-51.4-35.6-70-93.6-81.2-128.3-7-21.9-38.6-120.6-.2-151.2z"
        />
        <path className="item-search-scorecard_st3" d="M50 50h500v250H50z" />
      </g>
      <g id="item-search-scorecard_Page_Content_00000168075077691059184270000015150310478273558704_">
        <path
          className="item-search-scorecard_st3"
          d="M85.2 91.7c-2 0-3.7-1.7-3.7-3.7V72.2c0-2 1.7-3.7 3.7-3.7h79.1c2 0 3.7 1.7 3.7 3.7v15.7c0 2-1.7 3.7-3.7 3.7H85.2z"
        />
        <path
          className="item-search-scorecard_st2"
          d="M164.3 69c1.8 0 3.2 1.4 3.2 3.2v15.7c0 1.8-1.4 3.2-3.2 3.2H85.2c-1.8 0-3.2-1.4-3.2-3.2V72.2c0-1.8 1.4-3.2 3.2-3.2h79.1m0-1H85.2c-2.3 0-4.2 1.9-4.2 4.2v15.7c0 2.3 1.9 4.2 4.2 4.2h79.1c2.3 0 4.2-1.9 4.2-4.2V72.2c0-2.3-1.9-4.2-4.2-4.2z"
        />
        <path
          className="item-search-scorecard_st3"
          d="M176.9 91.7c-2 0-3.7-1.7-3.7-3.7V72.2c0-2 1.7-3.7 3.7-3.7H256c2 0 3.7 1.7 3.7 3.7v15.7c0 2-1.7 3.7-3.7 3.7h-79.1z"
        />
        <path
          className="item-search-scorecard_st2"
          d="M256 69c1.8 0 3.2 1.4 3.2 3.2v15.7c0 1.8-1.4 3.2-3.2 3.2h-79.1c-1.8 0-3.2-1.4-3.2-3.2V72.2c0-1.8 1.4-3.2 3.2-3.2H256m0-1h-79.1c-2.3 0-4.2 1.9-4.2 4.2v15.7c0 2.3 1.9 4.2 4.2 4.2H256c2.3 0 4.2-1.9 4.2-4.2V72.2c0-2.3-1.9-4.2-4.2-4.2z"
        />
        <path
          className="item-search-scorecard_st3"
          d="M268.6 91.7c-2 0-3.7-1.7-3.7-3.7V72.2c0-2 1.7-3.7 3.7-3.7h79.1c2 0 3.7 1.7 3.7 3.7v15.7c0 2-1.7 3.7-3.7 3.7h-79.1z"
        />
        <path
          className="item-search-scorecard_st2"
          d="M347.7 69c1.8 0 3.2 1.4 3.2 3.2v15.7c0 1.8-1.4 3.2-3.2 3.2h-79.1c-1.8 0-3.2-1.4-3.2-3.2V72.2c0-1.8 1.4-3.2 3.2-3.2h79.1m0-1h-79.1c-2.3 0-4.2 1.9-4.2 4.2v15.7c0 2.3 1.9 4.2 4.2 4.2h79.1c2.3 0 4.2-1.9 4.2-4.2V72.2c0-2.3-1.9-4.2-4.2-4.2z"
        />
        <path
          className="item-search-scorecard_st3"
          d="M360.4 91.7c-2 0-3.7-1.7-3.7-3.7V72.2c0-2 1.7-3.7 3.7-3.7h79.1c2 0 3.7 1.7 3.7 3.7v15.7c0 2-1.7 3.7-3.7 3.7h-79.1z"
        />
        <path
          className="item-search-scorecard_st2"
          d="M439.4 69c1.8 0 3.2 1.4 3.2 3.2v15.7c0 1.8-1.4 3.2-3.2 3.2h-79.1c-1.8 0-3.2-1.4-3.2-3.2V72.2c0-1.8 1.4-3.2 3.2-3.2h79.1m0-1h-79.1c-2.3 0-4.2 1.9-4.2 4.2v15.7c0 2.3 1.9 4.2 4.2 4.2h79.1c2.3 0 4.2-1.9 4.2-4.2V72.2c0-2.3-1.9-4.2-4.2-4.2z"
        />
        <path
          d="M514 92.2h-24.3c-2.2 0-4-1.8-4-4V72c0-2.2 1.8-4 4-4H514c2.2 0 4 1.8 4 4v16.2c0 2.2-1.8 4-4 4z"
          fill="#e8e8ea"
        />
        <path
          className="item-search-scorecard_st5"
          d="M476.7 92.2h-24.3c-2.2 0-4-1.8-4-4V72c0-2.2 1.8-4 4-4h24.3c2.2 0 4 1.8 4 4v16.2c0 2.2-1.8 4-4 4z"
        />
        <path
          className="item-search-scorecard_st2"
          d="M154.8 83.4l-3.6-3.6c-.3-.2-.3-.7 0-.9l.6-.6c.3-.2.7-.2.9 0l2.6 2.5 2.6-2.5c.3-.2.7-.2.9 0l.6.6c.3.2.3.7 0 .9l-3.6 3.6c-.4.2-.8.2-1 0zM246.5 83.4l-3.6-3.6c-.3-.2-.3-.7 0-.9l.6-.6c.3-.2.7-.2.9 0l2.6 2.5 2.6-2.5c.3-.2.7-.2.9 0l.6.6c.3.2.3.7 0 .9l-3.6 3.6c-.3.2-.7.2-1 0zM338.3 83.4l-3.6-3.6c-.3-.2-.3-.7 0-.9l.6-.6c.3-.2.7-.2.9 0l2.6 2.5 2.6-2.5c.3-.2.7-.2.9 0l.6.6c.3.2.3.7 0 .9l-3.6 3.6c-.3.2-.8.2-1 0zM430.1 83.4l-3.6-3.6c-.3-.2-.3-.7 0-.9l.6-.6c.3-.2.7-.2.9 0l2.6 2.5 2.6-2.5c.3-.2.7-.2.9 0l.6.6c.3.2.3.7 0 .9l-3.6 3.6c-.4.2-.8.2-1 0z"
        />
        <path fill="#eff0f2" d="M81 118.1h437V282H81z" />
        <path
          className="item-search-scorecard_st2"
          d="M514 99.9H85c-2.2 0-4 1.8-4 4V118h437v-14.1c0-2.2-1.8-4-4-4z"
        />
        <path
          className="item-search-scorecard_st7"
          d="M89.9 125.8h69.6v10.4H89.9zM244.4 125.8h37.2v10.4h-37.2zM319.4 125.8h37.2v10.4h-37.2zM394.5 125.8h37.2v10.4h-37.2zM469.5 125.8h37.2v10.4h-37.2zM117.6 152.5h69.6v10.4h-69.6z"
        />
        <path
          className="item-search-scorecard_st5"
          d="M267.8 162.9h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4zM342.8 162.9h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4zM417.9 162.9h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4zM492.9 162.9h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4z"
        />
        <path className="item-search-scorecard_st7" d="M117.6 179.2h59.2v10.4h-59.2z" />
        <path
          className="item-search-scorecard_st5"
          d="M267.8 189.5h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4zM342.8 189.5h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4zM417.9 189.5h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4z"
        />
        <path
          className="item-search-scorecard_st8"
          d="M492.9 189.5h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4z"
        />
        <path className="item-search-scorecard_st7" d="M117.6 205.8h77v10.4h-77z" />
        <path
          className="item-search-scorecard_st9"
          d="M267.8 216.2h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4z"
        />
        <path
          className="item-search-scorecard_st8"
          d="M342.8 216.2h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4z"
        />
        <path
          className="item-search-scorecard_st9"
          d="M417.9 216.2h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4z"
        />
        <path
          className="item-search-scorecard_st5"
          d="M492.9 216.2h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4z"
        />
        <path className="item-search-scorecard_st7" d="M117.6 232.5h66.5v10.4h-66.5z" />
        <path
          d="M267.8 242.9h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4z"
          fill="#c8d916"
        />
        <path
          className="item-search-scorecard_st11"
          d="M342.8 242.9h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4z"
        />
        <path
          className="item-search-scorecard_st9"
          d="M417.9 242.9h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4zM492.9 242.9h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4z"
        />
        <path className="item-search-scorecard_st7" d="M117.6 259.2h61.2v10.4h-61.2z" />
        <path
          className="item-search-scorecard_st12"
          d="M267.8 269.5h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4z"
        />
        <g>
          <path
            className="item-search-scorecard_st9"
            d="M342.8 269.5h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4z"
          />
        </g>
        <g>
          <path
            className="item-search-scorecard_st11"
            d="M417.9 269.5h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4z"
          />
        </g>
        <g>
          <path
            className="item-search-scorecard_st12"
            d="M492.9 269.5h-9.6c-2.2 0-4-1.8-4-4v-2.4c0-2.2 1.8-4 4-4h9.6c2.2 0 4 1.8 4 4v2.4c0 2.2-1.8 4-4 4z"
          />
        </g>
        <path
          className="item-search-scorecard_st13"
          d="M107.7 190.8h-4.4c-.8 0-1.2-1-.6-1.5l1.2-1.2c-1.7-1.7-3.3-3.4-5-5.2l-2.7 2.4c-.1 0-.3.2-.6.2-.4 0-.6-.2-.6-.3-1.6-1.8-3.2-3.6-4.9-5.4 0 0-.2-.2-.2-.4s.1-.3.1-.3l1.1-1.1s.1-.1.3-.1c.3 0 .4.2.4.2 1.3 1.5 2.6 2.9 3.8 4.4.9-.8 1.7-1.5 2.6-2.3 0 0 .3-.2.7-.2.3 0 .6.2.6.3 2 2 4 4.1 5.9 6.1l1.2-1.2c.6-.6 1.5-.2 1.5.6v4.3c.2.4-.1.7-.4.7zM107.7 270.8h-4.4c-.8 0-1.2-1-.6-1.5l1.2-1.2c-1.7-1.7-3.3-3.4-5-5.2l-2.7 2.4c-.1 0-.3.2-.6.2-.4 0-.6-.2-.6-.3-1.6-1.8-3.2-3.6-4.9-5.4 0 0-.2-.2-.2-.4s.1-.3.1-.3l1.1-1.1s.1-.1.3-.1c.3 0 .4.2.4.2 1.3 1.5 2.6 2.9 3.8 4.4.9-.8 1.7-1.5 2.6-2.3 0 0 .3-.2.7-.2.3 0 .6.2.6.3 2 2 4 4.1 5.9 6.1l1.2-1.2c.6-.6 1.5-.2 1.5.6v4.3c.2.4-.1.7-.4.7z"
        />
        <path
          className="item-search-scorecard_st5"
          d="M107.7 151.3h-4.4c-.8 0-1.2 1-.6 1.5l1.2 1.2c-1.7 1.7-3.3 3.4-5 5.2l-2.7-2.4c-.1 0-.3-.2-.6-.2-.4 0-.6.2-.6.3-1.6 1.8-3.2 3.6-4.9 5.4 0 0-.2.2-.2.4s.1.3.1.3l1.1 1.1s.1.1.3.1c.3 0 .4-.2.4-.2 1.3-1.5 2.6-2.9 3.8-4.4.9.8 1.7 1.5 2.6 2.3 0 0 .3.2.7.2.3 0 .6-.2.6-.3 2-2 4-4.1 5.9-6.1l1.2 1.2c.6.6 1.5.2 1.5-.6V152c.2-.5-.1-.7-.4-.7zM107.7 204.6h-4.4c-.8 0-1.2 1-.6 1.5l1.2 1.2c-1.7 1.7-3.3 3.4-5 5.2l-2.7-2.4c-.1 0-.3-.2-.6-.2-.4 0-.6.2-.6.3-1.6 1.8-3.2 3.6-4.9 5.4 0 0-.2.2-.2.4s.1.3.1.3l1.1 1.1s.1.1.3.1c.3 0 .4-.2.4-.2 1.3-1.5 2.6-2.9 3.8-4.4.9.8 1.7 1.5 2.6 2.3 0 0 .3.2.7.2.3 0 .6-.2.6-.3 2-2 4-4.1 5.9-6.1l1.2 1.2c.6.6 1.5.2 1.5-.6v-4.3c.2-.4-.1-.7-.4-.7z"
        />
        <path className="item-search-scorecard_st7" d="M89.9 236.2h18.4v2.9H89.9z" />
      </g>
    </svg>
  )
}

export default ItemSearchScorecard
